exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-loader[data-v-31662136]{min-height:400px;height:100%;width:100%;position:absolute;top:0;left:0;background:hsla(0,0%,100%,.74);z-index:2;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.md-progress-spinner.md-theme-default[data-v-31662136] .md-progress-spinner-circle{stroke:#ff6d00!important}", ""]);

// exports
